import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
   // Common Settings for Horizontal and Vertical Navigation
   public navLayout = 'vertical';  // Value Should be 'horizontal' or 'vertical'
   public toggleStatus = true;     // Valverticalue Should be 'true' or 'false'
   public appWidth = 'wide'; // value Should be 'wide', 'box'
   public collapsedHeader = false;  // Value should be true, false
   public asidebarState: null;

   public headerColorTheme = 'dark';
   // public leftHeaderColorTheme = 'dark';
   public navbarColorTheme = 'dark';
   public contentSectionTheme = 'light';

   public defaultNavbar: string;    // Value Should be 'expended', 'collapsed', 'offcanvas', 'compact'
   public toggleNavbar: string;     // Value Should be 'expended', 'collapsed', 'offcanvas', 'compact'
   public navBarEffect: string;     // Value Should be 'shrink', 'push', 'overlay'
   public deviceType: string;       // Value should be phone, tablet, desktop

   // defaultVerticalMenu[0] = Default menu on phone
   // defaultVerticalMenu[1] = Default menu on tablet
   // defaultVerticalMenu[2] = Default menu on desktop

   public defaultVerticalMenu = ['offcanvas', 'collapsed', 'expanded'];

   // onToggleVerticalMenu[0] = Toggle menu on phone
   // onToggleVerticalMenu[1] = Toggle menu on tablet
   // onToggleVerticalMenu[2] = Toggle menu on desktop

   public onToggleVerticalMenu = ['expanded', 'expanded', 'collapsed'];

   // navBarMenuEffect[0] = Sidebar Toggle effect on phone
   // navBarMenuEffect[1] = Sidebar Toggle effect on tablet
   // navBarMenuEffect[2] = Sidebar Toggle effect on desktop

   // public navBarMenuEffect = ['overlay', 'push', 'shrink'];
   public navBarMenuEffect = ['overlay', 'push', 'shrink'];

    // defaultDeviceType[0] = breakpoint for phone
   // defaultDeviceType[1] = breakpoint for tablet
   // defaultDeviceType[2] = breakpoint for desktop

   public defaultDeviceType = ['phone', 'tablet', 'desktop'];

   public setAsidebarState = new BehaviorSubject<string>(this.asidebarState);
   castAsidebarState = this.setAsidebarState.asObservable();

   public setNavLayout = new BehaviorSubject<string>(this.navLayout);
   castNavLayout = this.setNavLayout.asObservable();

   public setDeviceType = new BehaviorSubject<string>(this.deviceType);
   castDeviceType = this.setDeviceType.asObservable();

   public tStatus = new BehaviorSubject<boolean>(this.toggleStatus);
   castToggleStatus = this.tStatus.asObservable();

   public dfNavbar = new BehaviorSubject<string>(this.defaultNavbar);
   castdfNavbar = this.dfNavbar.asObservable();

   public tNavbar = new BehaviorSubject<string>(this.toggleNavbar);
   castToggleNavbar = this.tNavbar.asObservable();

   public nvEffect = new BehaviorSubject<string>(this.navBarEffect);
   castNavbarEffect = this.nvEffect.asObservable();

   public SetAppWidth = new BehaviorSubject<string>(this.appWidth);
   castSetAppWidth = this.SetAppWidth.asObservable();

   private setHeaderTheme = new BehaviorSubject<string>(this.headerColorTheme);
   castHeaderTheme = this.setHeaderTheme.asObservable();

   public setNavbarTheme = new BehaviorSubject<string>(this.navbarColorTheme);
   castNavbarTheme = this.setNavbarTheme.asObservable();

   public setContentSectionTheme = new BehaviorSubject<string>(this.contentSectionTheme);
   castContentSectionTheme = this.setContentSectionTheme.asObservable();

   public setCollapsedHeader = new BehaviorSubject<boolean>(this.collapsedHeader);
   castCollapsedHeader = this.setCollapsedHeader.asObservable();

  constructor() { }

  getDeviceType(dt: string) {
    this.setDeviceType.next(dt);
  }
  getDefaultNavbar(defaultNavbar: string) {
    this.dfNavbar.next(defaultNavbar);
  }
  getNavBarEffect(navbarEffect: string) {
    this.nvEffect.next(navbarEffect);
  }
  getToggleNavbar(toggleNavbar: string) {
    this.tNavbar.next(toggleNavbar);
  }

  getToggleStatus() {
    this.toggleStatus = !this.toggleStatus;
    this.tStatus.next(this.toggleStatus);
  }
  checkWindowWidth(windowWidth: number) {
    if (this.navLayout === 'vertical') {
      if (windowWidth >= 768 && windowWidth <= 1024) {
        this.defaultNavbar = this.defaultVerticalMenu[1];
        this.toggleNavbar = this.onToggleVerticalMenu[1];
        this.navBarEffect = this.navBarMenuEffect[1];
        this.deviceType = this.defaultDeviceType[1];
      } else if (windowWidth < 768) {
        this.defaultNavbar = this.defaultVerticalMenu[0];
        this.toggleNavbar = this.onToggleVerticalMenu[0];
        this.navBarEffect = this.navBarMenuEffect[0];
        this.deviceType = this.defaultDeviceType[0];
      } else {
        this.defaultNavbar = this.defaultVerticalMenu[2];
        this.toggleNavbar = this.onToggleVerticalMenu[2];
        this.navBarEffect = this.navBarMenuEffect[2];
        this.deviceType = this.defaultDeviceType[2];
      }

    } else if (this.navLayout === 'horizontal') {
      if (windowWidth >= 768 && windowWidth <= 1024) {
        this.deviceType = this.defaultDeviceType[1];
      } else if (windowWidth < 768) {
        this.deviceType = this.defaultDeviceType[0];
      } else {
        this.deviceType = this.defaultDeviceType[2];
      }
    }
    this.getDeviceType(this.deviceType);
    this.getDefaultNavbar(this.defaultNavbar);
    this.getNavBarEffect(this.navBarEffect);
    this.getToggleNavbar(this.toggleNavbar);
  }

  getVerticalNavbarOnWindowResize(windowWidth: number) {
    this.checkWindowWidth(windowWidth);
  }
}
